import { Box } from "@material-ui/core";
import { Button, ContainerPage, OptionsMenu, TitlePage } from "components";
import { usePopup } from "hooks/usePopup";
import { useTableParams } from "hooks/useTableParams";
import { useState } from "react";
import { FiEdit2, FiRotateCcw } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";
import productBaseMarginService from "services/productBaseMarginService";
import { Table } from "shared";
import { formatDateTime, mapType } from "utils";

import { MarginDrawer } from "./components/MarginDrawer";
import { SourceChip, useStyles } from "./styles";

const formatUpdatedAt = value => {
  if (!value) return "-";
  const { date, time } = formatDateTime(value);
  return `${date} ${time}`;
};

const formatMargin = value =>
  value === null || value === undefined ? "-" : Number(value).toFixed(2);

export const ProductBaseMargins = () => {
  const classes = useStyles();
  const { addPopup } = usePopup();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { data, onChange, params, refresh, status, handleSearch, count } =
    useTableParams({
      paramsDefault: { status: "active" },
      service: requestParams => productBaseMarginService.list(requestParams)
    });

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const handleDrawerExited = () => {
    setSelectedProduct(null);
  };

  const openDrawer = product => {
    setSelectedProduct(product || null);
    setDrawerOpen(true);
  };

  const removeMargin = async product => {
    try {
      await productBaseMarginService.remove(product.product_base_id);
      addPopup({
        type: "success",
        title: "Margem removida. A margem padrão 0,95 será utilizada."
      });
      refresh();
    } catch {
      addPopup({ type: "error", title: "Erro ao remover margem." });
    }
  };

  const columns = [
    {
      field: "product_base_id",
      label: "ID",
      align: "center",
      disabledSort: true,
      style: { width: "6rem" }
    },
    {
      field: "product_base_name",
      label: "Produto",
      align: "left",
      disabledSort: true
    },
    {
      field: "purchase_type",
      label: "Porção",
      align: "center",
      disabledSort: true,
      formatter: mapType
    },
    {
      field: "effective_margin",
      label: "Margem usada",
      align: "center",
      disabledSort: true,
      formatter: formatMargin
    },
    {
      field: "uses_default_margin",
      label: "Origem",
      align: "center",
      disabledSort: true,
      formatter: value => (
        <SourceChip
          size="small"
          isDefault={value}
          label={value ? "Padrão 0,95" : "Cadastrada"}
        />
      )
    },
    {
      field: "margin_updated",
      label: "Atualizado em",
      align: "center",
      disabledSort: true,
      formatter: formatUpdatedAt
    },
    {
      field: "updated_by_name",
      label: "Editado por",
      align: "center",
      disabledSort: true,
      formatter: value => value || "-"
    },
    {
      field: "",
      label: "",
      disabledSort: true,
      renderCell: ({ data: product }) => {
        const options = [
          {
            title: "Visualizar/editar",
            icon: FiEdit2,
            permissions: ["Estoque", "Tech", "Admin", "Stock View"],
            action: () => openDrawer(product)
          }
        ];

        if (!product.uses_default_margin) {
          options.push({
            title: "Usar margem padrão 0,95",
            icon: FiRotateCcw,
            permissions: ["Estoque", "Tech", "Admin", "Stock View"],
            action: () => removeMargin(product)
          });
        }

        return <OptionsMenu data={product} options={options} />;
      }
    }
  ];

  return (
    <ContainerPage>
      <Box className={classes.header}>
        <TitlePage>Margens de estoque</TitlePage>
        <Box>
          <Button
            variant="contained"
            startIcon={<IoMdAdd />}
            onClick={() => openDrawer()}
          >
            Adicionar
          </Button>
        </Box>
      </Box>

      <Table
        handleSearch={handleSearch}
        columns={columns}
        data={data}
        onChange={onChange}
        params={params}
        status={status}
        refresh={refresh}
        count={count}
        placeholder="Pesquisar produto"
      />

      <MarginDrawer
        open={drawerOpen}
        close={closeDrawer}
        onExited={handleDrawerExited}
        product={selectedProduct}
        onSaved={refresh}
      />
    </ContainerPage>
  );
};
